export default (store) => {
  store.subscribe((mutation) => {
    if (mutation.type === "organization/setOrganization") {
      store.dispatch("location/init");
      //store.dispatch("terminal/init");
      store.dispatch("businessActivation/init");
    }
  });
};
